/* eslint-disable @typescript-eslint/naming-convention */
import {
  LayoutGridIcon,
  MailIcon,
  MessageIcon,
  SettingsIcon,
  type SvgIcon,
  UsersGroupIcon,
  UsersIcon,
} from "@pharaday/lighthouse";

export enum ToolTypeEnum {
  NOTE = "NOTE",
  EMAIL_WATCHER = "EMAIL_WATCHER",
  BUSINESS_DIRECTORY = "BUSINESS_DIRECTORY",
  BUSINESS_SETTINGS = "BUSINESS_SETTINGS",
  ADMIN = "ADMIN",
  COLLABORATIVE_CONTAINER = "COLLABORATIVE_CONTAINER",
}

export const mapToolTypeToIcon: Record<ToolTypeEnum, SvgIcon> = {
  [ToolTypeEnum.NOTE]: MessageIcon,
  [ToolTypeEnum.EMAIL_WATCHER]: MailIcon,
  [ToolTypeEnum.BUSINESS_DIRECTORY]: UsersIcon,
  [ToolTypeEnum.BUSINESS_SETTINGS]: SettingsIcon,
  [ToolTypeEnum.ADMIN]: LayoutGridIcon,
  [ToolTypeEnum.COLLABORATIVE_CONTAINER]: UsersGroupIcon,
};
